(() => {
  const shellSelector = '.acqua-product-hub-stage-shell';
  const roomSelector = '.acqua-product-hub-complete-room';
  let roomFocus = null;

  // The app moves the room node on tab renders. Retain its keyboard focus.
  document.addEventListener('focusin', (event) => {
    roomFocus = event.target.closest?.(roomSelector) ? event.target : null;
  });
  document.addEventListener('pointerdown', (event) => {
    if (!event.target.closest?.(roomSelector)) roomFocus = null;
  }, true);

  const positionRoom = (shell) => {
    if (!shell.isConnected) return;
    const stage = shell.querySelector(':scope > .acqua-product-hub-stage');
    const room = shell.querySelector(`:scope > ${roomSelector}`);
    if (!stage || !room) return;
    const range = room.dataset.setupContext === 'TAPWARE_RANGE';
    if (range ? stage.previousElementSibling === room : stage.nextElementSibling === room) return;
    // Move existing nodes only: preserve cards, tab listeners and disclosures.
    if (range) stage.before(room);
    else stage.after(room);
    if (document.activeElement === document.body && roomFocus?.isConnected && room.contains(roomFocus)) {
      roomFocus.focus({ preventScroll: true });
    }
  };

  const observer = new MutationObserver((records) => {
    const shells = new Set();
    for (const record of records) {
      if (record.target.matches?.(shellSelector)) shells.add(record.target);
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches(shellSelector)) shells.add(node);
        node.querySelectorAll(shellSelector).forEach((shell) => shells.add(shell));
      }
    }
    shells.forEach(positionRoom);
  });
  document.querySelectorAll(shellSelector).forEach(positionRoom);
  observer.observe(document.body, { childList: true, subtree: true });
})();
